import pluralize from 'pluralize';
import cloneDeep from 'lodash.clonedeep';

export default {
  data: () => {
    return {
      activeObject: 0,
      objects: [{}],
    };
  },

  methods: {
    saveObject(data, form) {
      this.$store.dispatch(
        data.id ? `admin/edit${this.inlineName}` : `admin/add${this.inlineName}`,
        { data, form })
      .then(() => {
        this.clearForm();
        this.setupObjects();
      });
    },

    setupObjects() {
      if (this[`active${this.formName}`][this.inlineId]) {
        const clonedObjects = cloneDeep(this[`active${this.formName}`][this.inlineId]);
        this.objects.splice(1, this.objects.length, ...clonedObjects);
      }
    },

    editObject(objectId) {
      this.activeObject = objectId;
    },

    deleteObject(object) {
      /* eslint-disable no-alert */
      if (confirm(
        `Are you sure you want to delete this ${pluralize.singular(this.inlineId)}?`)) {
        this.$store.dispatch(`admin/delete${this.inlineName}`, { inlineId: object.id }).then(() => {
          this.setupObjects();
        });
      }
    },

    clearForm() {
      this.$set(this.objects, 0, {});
      this.activeObject = 0;
    },
  },

  created() {
    this.setupObjects();
  },
};
